<template>
    <Select2 :options="options()" v-model="model" />
</template>

<script>
import Select2 from './Select2.vue';
import baseHelpers from '@/helpers/methods/helpers';
import { getMedicamentsAndSubstances } from '@/api/apiOther';
import Mark from 'mark.js';

async function getResults(toSeek, searchedTerm, matchingMethod = 'startsWith') {
    const MAX_RESULTS = 100;
    let source = await getMedicamentsAndSubstances();
    let results = [];

    for (let key in toSeek) {
        for (let i = 0; i < source[key].length; i++) {
            let item = source[key][i];

            if (results.some((i) => i.id == item.id)) {
                continue;
            }

            let matched = toSeek[key].some((field) => {
                if (matchingMethod == 'startsWith') {
                    return baseHelpers
                        .removeDiacritics(item[field])
                        .toLowerCase()
                        .startsWith(searchedTerm);
                }
                return searchedTerm
                    .split(' ')
                    .filter(Boolean)
                    .every((i) =>
                        baseHelpers
                            .removeDiacritics(item[field])
                            .toLowerCase()
                            .includes(i)
                    );
            });

            if (matched) {
                results.push(item);
            }

            if (results.length === MAX_RESULTS) {
                return results;
            }
        }
    }

    if (results.length < MAX_RESULTS && matchingMethod == 'startsWith') {
        let extra = await getResults(toSeek, searchedTerm, null);
        results.push(...extra.filter((item) => !results.some((i) => i.id == item.id)));
    }

    return results;
}

function resultTypeTitle(type) {
    let map = {
        medicament: 'lék',
        substance: 'látka',
        allergen: 'alergen',
        custom: 'vlastní',
    };
    return map[type];
}

export default {
    props: ['value', 'field', 'type'],
    components: {
        Select2,
    },
    data() {
        return {
            model: this.value,
        };
    },
    methods: {
        options() {
            return {
                tags: true,
                delay: 300,
                placeholder: this.field.placeholder || 'Vyhledat',
                // dropdownAutoWidth: true, // Causes negative left position with long texts
                minimumInputLength: 1,
                createSearchChoice(term, items) {
                    if (!items.some((i) => i.text.toLowerCase() == term.toLowerCase())) {
                        return {
                            id: term,
                            text: term,
                            type: 'custom',
                        };
                    }
                },
                createSearchChoicePosition: 'bottom',
                query: async (options) => {
                    let term = baseHelpers.removeDiacritics(options.term.trim()).toLowerCase();
                    if (this.type == 'medicaments') {
                        let results = await getResults({ medicamentTitles: ['text'] }, term);
                        options.callback({ results });
                    } else if (this.type == 'allergies') {
                        let results = await getResults(
                            {
                                medicamentTitles: ['text'],
                                substances: ['id', 'text'],
                                allergens: ['text'],
                            },
                            term
                        );
                        options.callback({ results });
                    }
                },
                formatSelection(i, container, escapeMarkup) {
                    return escapeMarkup(i.text) + (i.type === 'custom' ? ' <b>(vlastní)</b>' : '');
                },
                formatResult(i, container, query, escapeMarkup) {
                    let root = document.createElement('div');
                    root.classList.add('flex', 'items-center', 'w-full');

                    let text = document.createElement('span');
                    text.classList.add('mr-2');
                    text.innerText = i.text;
                    let instance = new Mark(text);
                    instance.mark(query.term);
                    root.append(text);

                    if (i.type === 'custom') {
                        root.classList.add('font-bold');
                    }
                    if (i.type) {
                        let label = document.createElement('span');
                        label.classList.add('ml-auto', 'p-1', 'text-xs', 'text-black');
                        label.style.backgroundColor = i.type === 'custom' ? '#ffd07a' : '#e6f7ff';
                        label.innerText = resultTypeTitle(i.type);
                        root.append(label);
                    }
                    return root.outerHTML;
                },
            };
        },
    },
    watch: {
        value() {
            this.model = this.value;
        },
        model: {
            deep: true,
            handler() {
                this.$emit('input', this.model);
            },
        },
    },
};
</script>
